import { Link } from "react-router-dom";
import theme from "@monorepo/styles/theme";
import { Button, styled } from "@mui/material";

export const StyledLink = styled(Link)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  height: "100%",
  textDecoration: "none",
}));

export const StyledButton = styled(Button)(() => ({
  "&:hover": {
    color: theme.palette.primary.main,
  },
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
  height: "100%",
  color: theme.palette.text.disabled,
}));

export const IconStyle = { width: { xs: 35, sm: 45, md: 55 }, height: { xs: 35, sm: 45, md: 55 } };

export const IconsBoxStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1px 1fr",
  gridTemplateRows: "auto 1px auto",
  gap: theme.spacing(2),
  justifyItems: "center",
  alignItems: "center",
  width: "100%",
};
